module.exports = __webpack_public_path__ + "static/media/battery-cable-replacement-red.9641ace4.svg";